var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-videos__empty-state" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column justify-content-center" },
      [
        _c("VsEmptyState", {
          attrs: {
            icon: _vm.options.icon,
            name: _vm.options.name,
            src: _vm.options.src,
            title: _vm.options.title,
            message: _vm.options.message
          }
        }),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }